import { SxProps, Theme } from '@mui/material/styles'

export const styles = {
  scrollable: {
    width: 'max-content',
  } as SxProps<Theme>,
  scrollableContainer: {
    maxWidth: '100%',
    scrollSnapType: 'x mandatory',
    WebkitOverflowScrolling: 'touch',
    overflowX: 'scroll',
  } as SxProps<Theme>,
}
